module.exports = __webpack_public_path__ + "img/restaurant-4.7fd028bf.jpg";